// Dashboard metric aggregators — back the SLA / Driver perf / COD widgets.
// All endpoints are GET-only and business-scoped server-side.

import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface ISlaMetrics {
  windowMinutes: number;
  totalSlaRows: number;
  totalBreached: number;
  totalDueSoon: number;
  breachRate: number;
  bySeverity: Array<{ severity: string; count: number }>;
}

export interface IDriverStats {
  driverUserId: string;
  ratingCount: number;
  avgRating: number;
}

export interface IDriverPerf {
  windowDays: number;
  topDrivers: IDriverStats[];
  bottomDrivers: IDriverStats[];
  totalDriversRated: number;
  overallAvgRating: number;
}

export interface ICodMetrics {
  windowDays: number;
  pendingCount: number;
  settledCount: number;
  totalExpected: number;
  totalActual: number;
  totalDiscrepancy: number;
}

export const sla = async (params?: { windowMinutes?: number; dueSoonHours?: number }) =>
  httpRequest.get("/ord/metrics/sla", (params ?? {}) as never) as Promise<ISlaMetrics>;

export const driverPerf = async (params?: { windowDays?: number; limit?: number }) =>
  httpRequest.get("/ord/metrics/driver-perf", (params ?? {}) as never) as Promise<IDriverPerf>;

export const cod = async (params?: { windowDays?: number }) =>
  httpRequest.get("/ord/metrics/cod", (params ?? {}) as never) as Promise<ICodMetrics>;

export interface IActiveDriverLocation {
  deliveryNoteId: string;
  driverUserId: string;
  latitude: number;
  longitude: number;
  headingDeg: number | null;
  speedKmh: number | null;
  recordedAt: string;
}

export const driverLocations = async (params?: { freshMinutes?: number }) =>
  httpRequest.get("/ord/metrics/driver-locations", (params ?? {}) as never) as Promise<{
    rows: IActiveDriverLocation[];
    count: number;
  }>;

export interface IDeliveryStatusBucket {
  status: string;
  count: number;
}

export interface IDeliveryStatusMetrics {
  windowDays: number;
  total: number;
  byStatus: IDeliveryStatusBucket[];
}

export const deliveryStatus = async (params?: { windowDays?: number }) =>
  httpRequest.get("/ord/metrics/delivery-status", (params ?? {}) as never) as Promise<IDeliveryStatusMetrics>;
